import { ListItemConfig } from '@elements/collections/ListItem';

export const applyFilter = (items: ListItemConfig[], searchText = '') =>
    items.filter(({ title }) => title.toLowerCase().includes(searchText.toLowerCase()));
